import * as React from "react";

export const IconScan = (props: React.SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_35770_20322)">
      <path
        d="M16.5 8.91602L3.5 4.16602L2.91667 5.74935L14.6667 9.99935L4.16667 9.99935C3.25 9.99935 2.5 10.7493 2.5 11.666L2.5 14.9993C2.5 15.916 3.25 16.666 4.16667 16.666H15.8333C16.75 16.666 17.5 15.916 17.5 14.9993V10.416C17.5 9.74935 17.0833 9.08268 16.5 8.91602ZM5.83333 14.166H4.16667V12.4993H5.83333V14.166ZM15.8333 14.166L7.5 14.166V12.4993L15.8333 12.4993V14.166Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_35770_20322">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
